import React, {useEffect, useState} from "react";
import {Editor} from "primereact/editor";
import {Button} from "primereact/button";
import GeneralUtils from "../../../utils/GeneralUtils";
import {NoteService} from "../../../service/NoteService";
import {Card} from "primereact/card";
import {Badge} from "primereact/badge";
import {Divider} from "primereact/divider";
import {ConfirmDialog} from "primereact/confirmdialog";
import {SelectButton} from "primereact/selectbutton";
import {toast} from "react-toastify";

const defaultDescription = 'Notunuzu girin.';
const Note = (props) => {
    const {course, chapter, lecture, currentTime, displayNoteEditor, setDisplayNoteEditor} = props
    const [data, setData] = useState([]);
    const [description, setDescription] = useState(defaultDescription);
    // const [displayNoteEditorInCard, setDisplayNoteEditorInCard] = useState([]);
    const [activeIndex, setActiveIndex] = useState();
    const [visibleConfirmDialog, setVisibleConfirmDialog] = useState(false);
    const [sortOrder, setSortOrder] = useState('desc'); // 'desc' = En yeniye göre, 'asc' = En eskiye göre

    const sortOptions = [
        {label: 'En Yeniye Göre', value: 'desc'},
        {label: 'En Eskiye Göre', value: 'asc'}
    ];

    const service = new NoteService();

    useEffect(() => {
        service.findByCourseId(course.id).then(response => {
            if (!GeneralUtils.isNullOrEmpty(response)) {
                return setData(response);
            }
        });
    }, [course]);

    const formatDuration = (seconds) => {
        return new Date(seconds * 1000).toISOString().substr(11, 8);
    };

    const sortNotes = (notes, order) => {
        if (!notes || notes.length === 0) return notes;

        return [...notes].sort((a, b) => {
            const dateA = new Date(a.createdTime || 0);
            const dateB = new Date(b.createdTime || 0);

            if (order === 'asc') {
                return dateA - dateB; // En eskiden en yeniye
            } else {
                return dateB - dateA; // En yeniden en eskiye
            }
        });
    };

    const getSortedData = () => {
        return sortNotes(data, sortOrder);
    };

    const save = () => {
        if(GeneralUtils.isNullOrEmpty(chapter) || GeneralUtils.isNullOrEmpty(lecture)){
            return toast.warn('Lütfen önce bir ders seçin.');
        }
        const data = {
            description: description,
            course: course,
            chapter: chapter,
            lecture: lecture,
            position: currentTime
        }
        service.create(data).then(() => {
                service.findByCourseId(course.id).then(response => {
                    if (!GeneralUtils.isNullOrEmpty(response)) {
                        setDisplayNoteEditor(false);
                        setDescription(defaultDescription);
                        return setData(response);
                    }
                });
            }
        );
    }

    const deleteNote = (note) => {
        service.delete(note.id).then(() => {
            service.findByCourseId(course.id).then(response => {
                if (!GeneralUtils.isNullOrEmpty(response)) {
                    return setData(response);
                }
            });
        });
    }

    const update = (note ,index) => {
        note.description = description;
        service.update(note).then(() => {
                service.findByCourseId(course.id).then(response => {
                    if (!GeneralUtils.isNullOrEmpty(response)) {
                        setActiveIndex(-1);
                        setDescription(defaultDescription);
                        return setData(response);
                    }
                });
            }
        );
    }

    // const editNote = (note, index) => {
    //     let _displayNoteEditorInCard = displayNoteEditorInCard ? [...displayNoteEditorInCard] : [];
    //     _displayNoteEditorInCard[index] =  !_displayNoteEditorInCard[index];
    //     setDisplayNoteEditorInCard(_displayNoteEditorInCard);
    //     setDisplayNoteEditor(false);
    //     if(_displayNoteEditorInCard[index]){
    //         setDescription(note.description);
    //     } else{
    //         setDescription(defaultDescription);
    //     }
    // }

    const header = (
        <span className="ql-formats">
                <button className="ql-bold" aria-label="Bold"></button>
                <button className="ql-italic" aria-label="Italic"></button>
                <button className="ql-underline" aria-label="Underline"></button>
                <button className="ql-strike" aria-label="Strike"></button>
            </span>
    );

    const noteEditorInCard = (note, index) => (
        <div className="flex flex-column gap-2">
            <Editor id="description" value={description} onTextChange={(e) => setDescription(e.htmlValue)}
                    // headerTemplate={header}
                    style={{height: '120px'}}/>
            <div className="flex gap-2 justify-content-end">
                <Button label="İptal" onClick={() => {setActiveIndex(-1);setDescription(defaultDescription);}} outlined size="small"/>
                <Button label="Kaydet" onClick={()=> update(note, index)} raised size="small"/>
            </div>
        </div>
    )


    const noteEditor = (
        <div className="flex flex-column gap-2 mb-3">
            <div className="flex align-items-center gap-2">
                <Badge value={formatDuration(currentTime)} severity="info"/>
            </div>
            <Editor id="description" value={description} onTextChange={(e) => setDescription(e.htmlValue)}
                    // headerTemplate={header}
                    style={{height: '120px'}}/>
            <div className="flex gap-2 justify-content-end">
                <Button label="İptal" onClick={() => setDisplayNoteEditor(false)} outlined size="small"/>
                <Button label="Kaydet" onClick={save} raised size="small"/>
            </div>
        </div>
    )

    return (
        <>
            {data && data.length > 1 && (
                <div className="flex align-items-center justify-content-between mb-2">
                    <h5 className="m-0">Notlarım</h5>
                    <SelectButton
                        value={sortOrder}
                        onChange={(e) => setSortOrder(e.value)}
                        options={sortOptions}
                        size="small"
                    />
                </div>
            )}
            {displayNoteEditor && noteEditor}
            {getSortedData()?.map((note, index) => (
                <Card key={index} className='card noshadow'>
                    <div className="flex align-items-center justify-content-between">
                        <div className="flex flex-column gap-1" style={{flex: 1}}>
                            <div className="flex align-items-center gap-2">
                                <Badge value={formatDuration(note.position)} severity="info"/>
                                <span style={{fontSize: '0.9rem', color: '#495057', fontWeight: '600'}}>
                                    {note.chapter.objectIndex}. {note.chapter.title}
                                </span>
                                <span style={{fontSize: '0.85rem', color: '#6c757d', marginLeft: '3.5rem'}}>
                                {note.lecture.objectIndex}. {note.lecture.title}
                                </span>
                            </div>
                        </div>
                        <div className="flex gap-1">
                            <Button icon="pi pi-pencil" rounded text severity="secondary"
                                    tooltip="Düzenle" tooltipOptions={{position: 'top'}}
                                    onClick={() => {setActiveIndex(index); setDescription(note.description);}}/>
                            <Button icon="pi pi-trash" rounded text severity="danger"
                                    tooltip="Sil" tooltipOptions={{position: 'top'}}
                                    onClick={() => setVisibleConfirmDialog(true)}/>
                            <ConfirmDialog visible={visibleConfirmDialog} onHide={() => setVisibleConfirmDialog(false)}
                                           header="Silme Onayı"
                                           message="Kaydı Silmek İstediğinize Emin misiniz?"
                                           icon="pi pi-exclamation-triangle"
                                           acceptClassName='p-button-danger'
                                           acceptLabel='Evet'
                                           rejectLabel='Hayır'
                                           accept={() => deleteNote(note)}
                                           reject=""/>
                        </div>
                    </div>
                    <Divider style={{margin: "0.5rem 0"}}/>
                    {index !== activeIndex ? <div dangerouslySetInnerHTML={{__html: note.description}}/> :
                        noteEditorInCard(note, index)
                    }
                </Card>)
            )}
        </>
    );
};

export default Note;